
import { ExtraButtonLocation } from "@/models/extra-button";
import { Ticket } from "@/models/ticket";
import { ExtraButtonService } from "@/services";
import Vue from "vue";
import {ISelectItem} from "winfakt-vue-components";

export default Vue.extend({
	props: {
		ticket: {
			type: Object as ()=>Ticket,
			required: true
		}
	},
	computed: {
		actionList(): ISelectItem<Function>[] {
			let data:ISelectItem<Function>[] = [
				{text: "Bijlage toevoegen", value: ()=>this.triggerAction("attachFile"), icon: "paperclip"},
				{text: "Automatisch bericht zenden", value: ()=>this.triggerAction("autoMessage"), icon: "comment-dots"},
			];

			let extraButtons:ISelectItem<Function>[] = ExtraButtonService.getButtonsByLocation(ExtraButtonLocation.TICKETS).map(b=>b.toSelectItem(this.ticket));
			data.push(...extraButtons);
			return data;
		},
	},
	methods: {
		triggerAction(value: string) {
			this.$emit("input",value);
		},
	}
});
